export default "<tabbed-modal-tab tab=\"$ctrl.tab\">\r\n\t<metadata-tab export-log=\"$ctrl.exportLog\"></metadata-tab>\r\n</tabbed-modal-tab>\r\n";